export * from './featured-accommodations';
